
















































import { Component, Vue, Prop } from "vue-property-decorator";

import AddVariantFild from "@/components/app/shared/btn&dd/add-variant-fild.vue";
import ComplexMenuVariantListCard from "./complex-menu-variant-list-card.vue";
import AddComplexMenuVariantDishModal from "./add-complex-menu-variant-dish-modal.vue";
import AddComplexMenuVariantModal from "./add-complex-menu-variant-modal.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import type {
  ComplexMenuItem,
  ComplexMenuSheet,
} from "@/@types/menu/complex-menu";
import type { ComplexMenuVariant } from "@/@types/menu/complex-menu";

@Component({
  components: {
    StandartModal,
    AddVariantFild,
    ComplexMenuVariantListCard,
    AddComplexMenuVariantModal,
    AddComplexMenuVariantDishModal,
  },
})
class ComplexMenuListEditModal extends Vue {
  @Prop({ type: Object, default: null })
  active_complex_menu!: ComplexMenuSheet | null;

  variant_id = "";
  dish_index = -1;
  dishItem: ComplexMenuItem | null = null;

  get changedVariant(): ComplexMenuVariant | null {
    return (
      this.active_complex_menu?.menu.find((v) => v._id === this.variant_id) ||
      null
    );
  }

  setActive(current_variant: number): void {
    if (!this.active_complex_menu) return;
    this.$emit("changeSheet", this.active_complex_menu._id, {
      current_variant,
    });
  }

  onEditDish(variantId: string, dishIndex: number): void {
    this.variant_id = variantId;
    this.dish_index = dishIndex;

    const variant = this.active_complex_menu?.menu.find(
      (v) => v._id === variantId
    );
    if (!variant || !variant.menu[dishIndex]) return;

    this.dishItem = variant.menu[dishIndex];
    this.$bvModal.show("add-complex-menu-variant-dish");
  }

  onDishModalHide(): void {
    this.dishItem = null;
    this.dish_index = -1;
  }

  saveDish(dish: ComplexMenuItem): void {
    if (
      !this.changedVariant ||
      !this.active_complex_menu ||
      !this.changedVariant.menu
    )
      return;

    let updatedDishs: ComplexMenuItem[];

    if (dish._id && this.dish_index >= 0) {
      updatedDishs = [...this.changedVariant.menu];
      updatedDishs[this.dish_index] = dish;
    } else {
      updatedDishs = [...this.changedVariant.menu, dish];
    }

    const cleanedDishs = updatedDishs.map(({ _id, ...rest }) => rest);

    const updatedVariant = {
      ...this.changedVariant,
      menu: cleanedDishs,
    };

    const cleanedMenu = this.active_complex_menu.menu.map((variant) => {
      if (variant._id === updatedVariant._id) {
        return updatedVariant;
      }

      return {
        ...variant,
        menu: variant.menu.map(({ _id, ...rest }) => rest),
      };
    });

    this.$emit("changeSheet", this.active_complex_menu._id, {
      menu: cleanedMenu,
    });
    this.variant_id = "";
  }

  async removeDish(variantId: string, dishIndex: number): Promise<void> {
    if (!this.active_complex_menu) return;

    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete")),
          okVariant: "danger",
        }
      );
      if (result !== true) return;
    } catch {
      return;
    }

    const variant = this.active_complex_menu.menu.find(
      (v) => v._id === variantId
    );
    if (!variant) return;

    const updatedDishs = [...variant.menu];
    updatedDishs.splice(dishIndex, 1);

    const cleanedDishs = updatedDishs.map(({ _id, ...rest }) => rest);

    const updatedVariant = {
      ...variant,
      menu: cleanedDishs,
    };

    const cleanedMenu = this.active_complex_menu.menu.map((v) => {
      if (v._id === variantId) return updatedVariant;

      return {
        ...v,
        menu: v.menu.map(({ _id, ...rest }) => rest),
      };
    });

    this.$emit("changeSheet", this.active_complex_menu._id, {
      menu: cleanedMenu,
    });
  }

  async removeVariant(variantId: string): Promise<void> {
    if (!this.active_complex_menu) return;

    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete")),
          okVariant: "danger",
        }
      );
      if (result !== true) return;
    } catch {
      return;
    }

    const filteredMenu = this.active_complex_menu.menu.filter(
      (v) => v._id !== variantId
    );
    const cleanedMenu = filteredMenu.map(({ _id, ...v }, i) => ({
      ...v,
      variant: v.variant ?? i + 1,
      menu: v.menu ? v.menu.map(({ _id: dishId, ...dish }) => dish) : [],
    }));

    this.$emit("changeSheet", this.active_complex_menu._id, {
      menu: cleanedMenu,
    });
  }

  saveVariant(variant: ComplexMenuVariant): void {
    if (!this.active_complex_menu) return;

    const updatedMenu = [...this.active_complex_menu.menu, variant];
    const cleanedMenu = updatedMenu.map(({ _id, ...v }, i) => ({
      ...v,
      variant: v.variant ?? i + 1,
      menu: v.menu ? v.menu.map(({ _id: dishId, ...dish }) => dish) : [],
    }));

    this.$emit("changeSheet", this.active_complex_menu._id, {
      menu: cleanedMenu,
    });
  }
}
export default ComplexMenuListEditModal;
